import Vue from 'vue'
Vue.directive('autofocus', (el: any) => {
  setTimeout(() => {
    const input = el.querySelector('input') || el.querySelector('textarea')
    if (input) {
      input.focus()
    } else {
      el.focus()
    }
  }, 200)
})
